import { useEffect, useState } from "react";
import { Button, Collapse } from "react-bootstrap";
import { useSelector } from "react-redux";
import AwesomeIcon from "@icons/AwesomeIcon";

export const SntCollapse = ({
  children,
  isDisableCollapseOnMobile = false,
}) => {
  const { isMobile } = useSelector((state) => state.all);
  const [open, setOpen] = useState(
    isDisableCollapseOnMobile ? true : !isMobile
  );

  useEffect(() => {
    setOpen(isDisableCollapseOnMobile ? true : !isMobile);
  }, [isMobile, isDisableCollapseOnMobile]);

  return (
    <>
      {isMobile && !isDisableCollapseOnMobile && (
        <Button
          variant="sensolus-greylight"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          className="mb-2"
        >
          <AwesomeIcon icon="filter"></AwesomeIcon>
        </Button>
      )}
      <Collapse in={open}>{children}</Collapse>
    </>
  );
};
